const verification = {
  // Page titles
  title: 'التحقق من الهوية',
  subtitle: 'أكمل عملية التحقق للوصول إلى جميع الميزات',

  // Status and progress
  statusTitle: 'حالة التحقق',
  progress: 'التقدم',
  stepCompleted: 'مكتمل',
  startVerification: 'بدء التحقق',
  continueVerification: 'متابعة التحقق',
  verificationComplete: 'اكتمل التحقق',
  verificationCompleteDesc: 'تم التحقق من حسابك بنجاح وأصبحت مؤهلاً للحصول على شارة الوسيط الموثوق',
  comingSoon: 'قريباً',

  // Badge labels
  badges: {
    verified: 'وسيط موثوق',
    verifiedTooltip: 'تم التحقق من هذا الوسيط وهو يحقق معايير الجودة والالتزام',
    gold: 'وسيط ذهبي',
    goldTooltip: 'وسيط متميز بتقييمات عالية وسجل أداء ممتاز',
    platinum: 'وسيط بلاتيني',
    platinumTooltip: 'أعلى مستوى من التميز مع سجل حافل بالنجاحات',
    company: 'منشأة معتمدة',
    companyTooltip: 'شركة عقارية مرخّصة ومعتمدة من هيئة العقار',
  },

  // Requirements
  requirementsMet: 'متطلبات مكتملة',
  requirements: 'المتطلبات',
  benefits: 'المميزات',
  achieved: 'تم الحصول',
  currentGoal: 'هدفك الحالي',

  // Nafath verification
  nafath: {
    title: 'التحقق عبر نفاذ',
    description: 'قم بالتحقق من هويتك عبر تطبيق نفاذ',
    initiate: 'بدء التحقق',
    waitingTitle: 'في انتظار التحقق',
    waitingDescription: 'افتح تطبيق نفاذ وأكمل عملية التحقق',
    codeLabel: 'رمز التحقق',
    scanQR: 'أو امسح رمز QR',
    verified: 'تم التحقق بنجاح',
    verifiedDescription: 'تم التحقق من هويتك عبر نفاذ',
    failed: 'فشل التحقق',
    failedDescription: 'لم نتمكن من التحقق من هويتك. يرجى المحاولة مرة أخرى.',
    expired: 'انتهت صلاحية الجلسة',
    expiredDescription: 'انتهت صلاحية جلسة التحقق. يرجى المحاولة مرة أخرى.',
    cancel: 'إلغاء',
    retry: 'إعادة المحاولة',
    apiPending: 'سيتم تفعيل التحقق عبر نفاذ قريباً. نعمل على ربط الخدمة.',
    status: {
      not_started: 'لم يبدأ',
      pending: 'قيد الانتظار',
      completed: 'مكتمل',
      failed: 'فشل',
      expired: 'منتهي',
    },
  },

  // FAL license
  fal: {
    title: 'ربط رخصة فال',
    description: 'اربط رخصة الوساطة العقارية الخاصة بك',
    licenseNumber: 'رقم رخصة فال',
    licenseNumberPlaceholder: 'أدخل رقم الرخصة',
    link: 'ربط الرخصة',
    unlink: 'إلغاء الربط',
    linked: 'الرخصة مرتبطة',
    linkedDescription: 'رخصة فال مرتبطة بحسابك',
    notLinked: 'لم يتم ربط رخصة',
    notLinkedDescription: 'اربط رخصة فال للإعلان عن العقارات',
    verifying: 'جاري التحقق من الرخصة...',
    invalid: 'رخصة غير صالحة',
    invalidDescription: 'رقم الرخصة غير صحيح أو غير نشط',
    expired: 'الرخصة منتهية',
    expiredDescription: 'انتهت صلاحية الرخصة. يرجى تجديدها.',
    details: {
      holderName: 'اسم حامل الرخصة',
      type: 'نوع الرخصة',
      issueDate: 'تاريخ الإصدار',
      expiryDate: 'تاريخ الانتهاء',
      activities: 'الأنشطة المرخّصة',
    },
    status: {
      not_linked: 'غير مرتبطة',
      pending: 'قيد التحقق',
      active: 'نشطة',
      expired: 'منتهية',
      invalid: 'غير صالحة',
    },
  },

  // Owner verification wizard
  owner: {
    title: 'التحقق من ملكية العقار',
    description: 'أكمل الأسئلة التالية للتحقق من ملكيتك للعقار',
    startVerification: 'بدء التحقق',
    continueVerification: 'متابعة التحقق',
    step: 'خطوة',
    of: 'من',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال للمراجعة',
    saveProgress: 'حفظ التقدم',

    // Question categories
    categories: {
      consent: 'موافقة التمثيل',
      identity: 'التحقق من الهوية',
      ownership: 'إثبات الملكية',
      authorization: 'التفويض الرسمي',
      propertyDetails: 'تفاصيل العقار',
      contact: 'بيانات التواصل',
      declarations: 'الإقرارات النظامية',
      license: 'ترخيص الإعلان',
      signature: 'التوقيع الإلكتروني',
    },

    // Common question labels
    questions: {
      consent: 'هل توافق على أن تقوم المنصة بتمثيلك كوسيط عقاري؟',
      representationType: 'نوع التمثيل المطلوب',
      verifyNafath: 'التحقق عبر نفاذ',
      isOwner: 'هل أنت المالك المسجل في الصك؟',
      deedType: 'نوع الصك',
      deedNumber: 'رقم الصك',
      isMortgaged: 'هل العقار مرهون؟',
      hasDisputes: 'هل توجد نزاعات قانونية على العقار؟',
      authorizationType: 'نوع التفويض',
      authorizationDuration: 'مدة التفويض',
      listingType: 'نوع الإعلان',
      propertyType: 'نوع العقار',
      location: 'موقع العقار',
      price: 'السعر المطلوب',
      isPriceNegotiable: 'هل السعر قابل للتفاوض؟',
      specialConditions: 'شروط خاصة',
      contactReceiver: 'من يستقبل التواصل؟',
      shareData: 'هل توافق على مشاركة بياناتك مع المهتمين؟',
      declareLegalOwner: 'أقر بأنني المالك الشرعي',
      declareAuthorization: 'أقر بتفويض المنصة رسمياً',
      declareDataAccuracy: 'أقر بصحة جميع البيانات',
      declareResponsibility: 'أتحمل المسؤولية في حال تقديم معلومات خاطئة',
      consentLicense: 'هل توافق على إصدار ترخيص الإعلان باسم المنصة كوسيط؟',
      signContract: 'التوقيع على عقد الوساطة',
    },

    // Options
    options: {
      representationType: {
        adOnly: 'إعلان فقط',
        adAndMarketing: 'إعلان + تسويق',
        full: 'إعلان + تسويق + استقبال طلبات',
      },
      deedType: {
        electronic: 'إلكتروني',
        paper: 'ورقي',
      },
      authorizationType: {
        absher: 'تفويض إلكتروني عبر أبشر',
        contract: 'عقد وساطة إلكتروني',
      },
      authorizationDuration: {
        oneMonth: 'شهر',
        threeMonths: '3 أشهر',
        sixMonths: '6 أشهر',
      },
      listingType: {
        sale: 'بيع',
        rent: 'إيجار',
      },
      contactReceiver: {
        platform: 'المنصة',
        owner: 'المالك',
      },
    },

    // Status
    status: {
      not_started: 'لم يبدأ',
      in_progress: 'قيد التقدم',
      pending_review: 'قيد المراجعة',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
    },

    // Messages
    progressSaved: 'تم حفظ تقدمك',
    submittedForReview: 'تم إرسال طلبك للمراجعة',
    reviewTime: 'سيتم مراجعة طلبك خلال 24-48 ساعة',
  },

  // General
  steps: {
    identity: 'التحقق من الهوية',
    license: 'رخصة فال',
    completed: 'مكتمل',
  },
  verificationRequired: 'التحقق مطلوب',
  verificationRequiredDescription: 'يجب إكمال التحقق للوصول إلى هذه الميزة',
  completeVerification: 'أكمل التحقق',
};

export default verification;
